// extracted by mini-css-extract-plugin
export var buttonContainer = "_6l-1";
export var fontSizeSelect = "_6l-3";
export var formatSelect = "_6l-2";
export var formats = "_6l-4";
export var hidden = "_6l-5";
export var icon = "_6l-6";
export var select = "_6l-0";